import { Store } from '@ngrx/store';
import { BrokerService } from '@c4/core';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';

import { LightsService } from './../services/lights.service';
import { SharedProgrammingService } from '../../../common/services/shared-programming.service';
import { Location } from '../../../common/interfaces/item.interface';
import { LocationsService } from '../../../common/services/locations.service';
import { LightSceneRef } from '../services/interfaces/light.interface';
import { BaseRoutingComponent } from '../../../common/base-routing/base-routing.component';

@Component({
  selector: 'prg-simple-list',
  templateUrl: './light-scene-list.component.html',
  styleUrls: ['./light-scene-list.component.less']
})
export class LightSceneListComponent extends BaseRoutingComponent {

  private _scenes: Observable<LightSceneRef[]>;

  private _selectedRoom: any;
  private _rooms: Observable<Location[]>;
  private _searchText: string;

  constructor(
    private route: ActivatedRoute,
    private shared: SharedProgrammingService,
    private lights: LightsService,
    private locations: LocationsService,
    private broker: BrokerService,
    protected store: Store<any>,
    protected router: Router
  ) {
    super();
    this._rooms = this.locations.rooms;
    this._selectedRoom = '0';

    this._allScenes = Observable.fromPromise(this.broker.call({
      path: '/api/v1/agents/advanced_lighting'
    }));
  }

  ngOnInit() {
    this.setScenes();
  }

  setScenes() {
    let roomId = parseInt(this._selectedRoom);
    console.log('lights: selected room is', roomId);
    if (roomId > 0) {
      this._scenes = Observable.fromPromise(this.broker.call({
        path: '/api/v1/locations/rooms/' + roomId + '/light_scenes'
      })).map(scenes => scenes.visible);
    } else {
      this._scenes = this._allScenes;
    }
  }

  private _allScenes: Observable<LightSceneRef[]>;
}

interface RoomScene {
  id: number;
  name: string;
  light_scenes: LightSceneRef[];
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstart-lights/light-scene-list/light-scene-list.component.ts